module.exports = __webpack_public_path__ + "static/assets/69e164fac0cca66c053ecb31c9c2aa64.png";